// extracted by mini-css-extract-plugin
export default {"languagePopup":"Languages_languagePopup__DxH5N","languageCont":"Languages_languageCont__fqZnL","languageMain":"Languages_languageMain__boGNh","list":"Languages_list__PO9Ou"};